import { DatePicker, DatePickerProps, Form, Select } from "antd";
import { Rule } from "antd/es/form";
import type { RefSelectProps } from "antd/es/select";
import React, { forwardRef } from "react";

import { ParseObjectSelect } from "@opendash/plugin-parse";
import dayjs, { Dayjs } from "dayjs";
import {
  ArrayValueType,
  ParseDateRestType,
} from "../../types/ArrayValueInputDataTypes";
import { Operation } from "../../types/FormValues";

type Props = {
  index: number;
  styles: React.CSSProperties;
  rules: Rule[];
  label: string;
  type: "string" | "number" | "boolean";
  operation: Operation;
};

export default (props: Props) => {
  return (
    <Form.Item
      label={props.label}
      name={[props.index, "value"]}
      rules={props.rules}
      style={{ width: "100%", flexGrow: 1, ...props.styles }}
    >
      <SelectWrapper type={props.type} operation={props.operation} />
    </Form.Item>
  );
};

interface CustomInputProps {
  value?: ArrayValueType[]; // Controlled value
  onChange?: (value: ArrayValueType[]) => void; // Change handler
  placeholder?: string;
  type: "string" | "number" | "boolean" | "pointer" | "date";
  operation: Operation;
}

const SelectWrapper = forwardRef<RefSelectProps, CustomInputProps>(
  ({ value, onChange, placeholder, type, operation }, ref) => {
    if (type === "pointer") {
      return (
        <ParseObjectSelect
          mode="multiple"
          type={operation.field.targetClass}
          style={{}}
        />
      );
    }
    if (type === "date") {
      const innerOnChange: DatePickerProps<Dayjs[]>["onChange"] = (dates) => {
        if (onChange) {
          onChange(
            dates.map((d) => ({ __type: "Date", iso: d.toISOString() }))
          );
        }
      };
      return (
        <DatePicker
          multiple
          onChange={innerOnChange}
          value={(value as ParseDateRestType[])?.map((v) => {
            const date = v instanceof Date ? dayjs(v) : dayjs(v.iso);

            return date;
          })}
          picker="date"
        />
      );
    }

    const booleanOptions = [
      { label: "True", value: "true" },
      { label: "False", value: "false" },
    ];
    return (
      <Select
        ref={ref}
        value={value}
        mode={type === "boolean" ? "multiple" : "tags"}
        onChange={(e: (string | boolean | number)[]) => {
          let value = e;
          if (type === "number") {
            value = value.map((v) => Number(v));
          }
          if (type === "boolean") {
            value = value.map((v) => v === "true");
          }
          if (onChange) [onChange(value)];
        }}
        placeholder={placeholder}
        options={type === "boolean" ? booleanOptions : undefined}
      />
    );
  }
);
